'use client'

import React from 'react'

type Props = {
    mass: number
    specificHeat: number
    deltaT: number
}

const WIDTH = 340
const HEIGHT = 200
const PAD_LEFT = 50
const PAD_RIGHT = 12
const PAD_TOP = 14
const PAD_BOTTOM = 28
const PLOT_W = WIDTH - PAD_LEFT - PAD_RIGHT
const PLOT_H = HEIGHT - PAD_TOP - PAD_BOTTOM

export default function HeatTemperatureChart({ mass, specificHeat, deltaT }: Props) {
    const tMax = Math.max(Math.abs(deltaT) * 1.2, 0.1)
    const qAt = (dt: number) => mass * specificHeat * dt
    const qMax = Math.max(Math.abs(qAt(tMax)), Math.abs(qAt(-tMax)), 0.0001)

    const xToSvg = (dt: number) => PAD_LEFT + ((dt + tMax) / (2 * tMax)) * PLOT_W
    const yToSvg = (q: number) => PAD_TOP + PLOT_H - ((q + qMax) / (2 * qMax)) * PLOT_H

    const t1 = -tMax
    const t2 = tMax

    const markerX = xToSvg(deltaT)
    const markerY = yToSvg(qAt(deltaT))

    return (
        <svg width={WIDTH} height={HEIGHT} viewBox={`0 0 ${WIDTH} ${HEIGHT}`} style={{ maxWidth: '100%', height: 'auto' }}>
            <line x1={PAD_LEFT} y1={PAD_TOP} x2={PAD_LEFT} y2={HEIGHT - PAD_BOTTOM} stroke="#9ca3af" strokeWidth={1} />
            <line x1={PAD_LEFT} y1={yToSvg(0)} x2={WIDTH - PAD_RIGHT} y2={yToSvg(0)} stroke="#9ca3af" strokeWidth={1} />
            <text x={PAD_LEFT} y={HEIGHT - 8} fontSize={10} fill="#6b7280">ΔT (°C)</text>
            <text x={2} y={PAD_TOP + 6} fontSize={10} fill="#6b7280">Heat Q (J)</text>
            <line x1={xToSvg(t1)} y1={yToSvg(qAt(t1))} x2={xToSvg(t2)} y2={yToSvg(qAt(t2))} stroke="#dc2626" strokeWidth={2} />
            <line x1={markerX} y1={markerY} x2={markerX} y2={yToSvg(0)} stroke="#2563eb" strokeWidth={1} strokeDasharray="3,3" opacity={0.6} />
            <circle cx={markerX} cy={markerY} r={4.5} fill="#2563eb" stroke="#fff" strokeWidth={1.5} />
        </svg>
    )
}
